import { createContext, useContext } from 'react';

// contains the ID of the current cancel flow config
export const CancelFlowIdContext = createContext<string | undefined>(undefined);

export function useCancelFlowId() {
  return useContext(CancelFlowIdContext);
}
